import { JSMap } from "@bizform/type/model/component_element/ComponentElement.model";

/**
 * Rectangle Object
 *
 * @since 0.0.1
 * @author Jongkwang Park
 * @class
 */
class Rect {

    public x: number;
    public y: number;
    public vStartX: number;
    public vEndX: number;
    public vStartY: number;
    public vEndY: number;
    public width: number;
    public height: number;

    constructor(x: number, y: number, width: number, height: number) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }

    static empty(): Rect {
        const rect = new Rect(0, 0, 0, 0);
        rect.vStartX = 0;
        rect.vEndX = 0;
        rect.vStartY = 0;
        rect.vEndY = 0;

        return rect;
    }

    clone(): Rect {
        const rect = new Rect(this.x, this.y, this.width, this.height);
        rect.vStartX = this.vStartX;
        rect.vEndX = this.vEndX;
        rect.vStartY = this.vStartY;
        rect.vEndY = this.vEndY;

        return rect;
    }

    equals(rect: Rect): boolean {
        if (this.x === rect.x
            && this.y === rect.y
            && this.width === rect.width
            && this.height === rect.height) {
            return true;
        } else {
            return false;
        }
    }

    getBottom(): number {
        return this.y + this.height;
    }

    getRight(): number {
        return this.x + this.width;
    }

    positionElement(element: HTMLElement): void {
        this.styleWithPosition(element.style);
    }

    styleWithPosition(style: JSMap<any>): JSMap<any> {
        style.left = this.x + "px";
        style.top = this.y + "px";
        style.width = Math.max(0, this.width) + "px";
        style.height = Math.max(0, this.height) + "px";
        style.position = "absolute";
        return style;
    }

    contains(x: number, y: number): boolean {
        if (this.x <= x && x <= this.getRight()
            && this.y <= y && y <= this.getBottom()) {
            return true;
        } else {
            return false;
        }
    }

    toString(): string {
        return "(Rect: x=" + this.x
            + ", y=" + this.y
            + ", width=" + this.width
            + ", height=" + this.height
            + ", vStartX=" + this.vStartX
            + ", vEndX=" + this.vEndX
            + ", vStartY=" + this.vStartY
            + ", vEndY=" + this.vEndY
            + ")";
    }
}

export default Rect;

